// Utility to automatically optimize any Imgix URL
const optimizeImgixUrl = (url, options = {}) => {
  if (!url || typeof url !== 'string') return url;
  
  // Only optimize Imgix URLs
  if (!url.includes('herb-platform-images.imgix.net')) return url;
  
  const {
    quality = 75,
    auto = 'compress',
    format = 'auto'
  } = options;
  
  // Parse existing URL and params
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  
  // Add optimization params if not already present
  if (!params.has('auto')) params.set('auto', auto);
  if (!params.has('q')) params.set('q', quality);
  if (!params.has('fm')) params.set('fm', format);
  
  // Return optimized URL
  urlObj.search = params.toString();
  return urlObj.toString();
};

export default optimizeImgixUrl;
